import React, { ChangeEvent, useState } from "react";
import UserInfoEditPageContent from "../../components/organisms/UserInfoEditPageContent/UserInfoEditPageContent";
import { MoreDetailTemplates } from "../../components/template/MoreDetailTemplates";
import { useRecoilState, useRecoilValue } from "recoil";
import { userState } from "../../states/user";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useMutation } from "@tanstack/react-query";
import { request } from "../../lib/api";
import { PUT_USER_INFO } from "../../common/query-keys";
import UserInfoEditModal from "../../components/molcules/Modal/UserInfoEditModal";
import { useNavigate } from "react-router";

const schema = yup.object({
  username: yup.string(),
  phoneNumber: yup.string().min(13, "휴대폰 번호를 정확히 입력해주세요."),
  email: yup.string().nullable().email("이메일 형식이 아닙니다."),
  currentPassword: yup.string().nullable(),
  newPassword: yup
    .string()
    .nullable()
    .matches(
      /^(?=.*[a-z])(?=.*[0-9])|(?=.*[a-z])(?=.*[!@#$%^&*?_])|(?=.*[0-9])(?=.*[!@#$%^&*?_]).{8,12}$/,
      "비밀번호는 8~12자리의 영문, 숫자, 특수문자 중 2가지 이상의 조합으로 입력해야 합니다."
    ),
  newPasswordCheck: yup
    .string()
    .nullable()
    .oneOf([yup.ref("newPassword")], "비밀번호가 일치하지 않습니다."),
});

const UserInfoEditPage = () => {
  const [userData, setUserData] = useRecoilState(userState);
  const [isModal, setIsModal] = useState<boolean>(false);
  const navigate = useNavigate();
  const {
    register,
    setValue,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {
      username: userData?.username,
      phoneNumber: userData?.profile.phoneNumber,
      email: userData?.profile.email,
      currentPassword: null,
      newPassword: null,
      newPasswordCheck: null,
    },
    resolver: yupResolver(schema),
  });

  /** 정보 변경 함수 */
  const onSubmit = async (data: any) => {
    let userUpdateData: any = await putUserInfoEdit(data);
    delete userUpdateData.data["password"];
    setUserData(userUpdateData.data);
  };

  const { mutateAsync: putUserInfoEdit } = useMutation({
    mutationFn: (data: any) => {
      return request({
        method: "POST",
        url: PUT_USER_INFO,
        data: data,
      });
    },
    onSuccess: (res: any) => {
      if (!res.success) {
        alert(res.message);
      } else {
        setIsModal(true);
      }
    },
    onError: (e: any) => {
      console.log("@@@ ERRORS!: ", e);
    },
  });

  /** 휴대폰번호 자동으로 - 입력하게 하는 함수 */
  const handlePhoneNumberChange = (e: ChangeEvent<HTMLInputElement>) => {
    const phoneNumber = e.target.value.replace(/[^0-9]/g, "");
    let result = "";
    if (phoneNumber.length < 4) {
      result = phoneNumber;
    } else if (phoneNumber.length < 7) {
      result = phoneNumber.substring(0, 3) + "-" + phoneNumber.substring(3);
    } else if (phoneNumber.length < 11) {
      result =
        phoneNumber.substring(0, 3) +
        "-" +
        phoneNumber.substring(3, 6) +
        "-" +
        phoneNumber.substring(6);
    } else {
      result =
        phoneNumber.substring(0, 3) +
        "-" +
        phoneNumber.substring(3, 7) +
        "-" +
        phoneNumber.substring(7);
    }

    setValue("phoneNumber", result);
  };

  /** 이전으로 돌아가는 함수 */
  const onBackHanlder = () => {
    navigate(-1);
  };

  return (
    <>
      <MoreDetailTemplates pageTitle="내 정보 수정">
        <UserInfoEditPageContent
          handleSubmit={handleSubmit}
          register={register}
          onSubmit={onSubmit}
          handlePhoneNumberChange={handlePhoneNumberChange}
          onBackHanlder={onBackHanlder}
          errors={errors}
        />
      </MoreDetailTemplates>
      {isModal && <UserInfoEditModal onModalCloseHanlder={onBackHanlder} />}
    </>
  );
};

export default UserInfoEditPage;
